// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.0524902L23.9478 12.0003L22 13.9482V13.9999H21.9482L14.8284 21.1197C13.2663 22.6818 10.7336 22.6818 9.17154 21.1197L2.88056 14.8288C1.31846 13.2667 1.31846 10.734 2.88056 9.1719L7.31915 4.73331L4.58575 1.99991L5.99996 0.585693L8.73336 3.31909L12 0.0524902ZM8.73336 6.14752L4.29477 10.5861C3.90435 10.9765 3.70909 11.4882 3.70898 11.9999H21.119L12 2.88092L10.1476 4.73331L13.4142 7.99991L12 9.41412L8.73336 6.14752ZM21.75 18.3889L23.0643 20.049C23.6452 20.7827 23.6452 21.8965 23.0643 22.6302C22.7497 23.0276 22.2804 23.2869 21.75 23.2869C21.2195 23.2869 20.7503 23.0276 20.4356 22.6302C19.8548 21.8965 19.8548 20.7827 20.4356 20.049L21.75 18.3889Z"}}]};

const FillColor1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fill-color-1-filled',
    ref,
    icon: element,
  },
));

FillColor1FilledIcon.displayName = 'FillColor1FilledIcon';

export default FillColor1FilledIcon;
